import {Button} from '@mui/material';
import React, {Fragment} from 'react';

import {WellBornTaggingEnum} from 'main/analytics/gaTagsEnum';
import BeBornWellImgDesktop from 'presentation/assets/images/img-nascer-bem-desktop@2x.webp';
import {Loading} from 'presentation/components/Loading/Loading';
import Icon from 'presentation/icons';
import {CheckBookingModalEnum} from 'presentation/modules/booking/health/ui/pages/HealthBooking/steps/HealthSpecialtySelection/components/HealthSpecialtiesList/hooks/useHealthSpecialtiesSelection/types';
import {translations} from 'presentation/translations-new';
import {BeBornWellCard} from '../BeBornWellCard';
import {BeBornWellDrawer} from '../BeBornWellDrawer';
import {PendingDialog} from '../PendingDialog';
import {SpecialtyNotAvailableBeBornCard} from './components/SpecialtyNotAvailableBeBornCard';
import {useBeBornWellNotRegister} from './hooks/useBeBornWellNotRegister';
import {
	DescriptionTypography,
	StyledCard,
	StyledCardContent,
	StyledCardMedia,
	TitleTypography,
} from './styles';
import {BeBornWellNotRegisterProps} from './types';

const {beBornWellStep, buttons} =
	translations['pt-br'].privateFlow.bookingFlow.beBornWellFlow.beBornWellDrawer;

export function BeBornWellNotRegister({
	selectedSpecialty,
	handleSelectCard,
	checkBookingModal,
	handleCheckDuplicity,
}: BeBornWellNotRegisterProps) {
	const {
		showBeBornWellCard,
		openBeBornWellDrawer,
		isProcessing,
		handleRegisterClick,
		handleNotPregnantClick,
		handleShowBeBornWellCard,
		handleContinueToBooking,
		loadingText,
		setOpenBeBornWellDrawer,
	} = useBeBornWellNotRegister({
		selectedSpecialty,
		handleSelectCard,
		checkBookingModal,
	});

	return (
		<Fragment>
			{openBeBornWellDrawer ? (
				<BeBornWellDrawer
					open={openBeBornWellDrawer}
					setOpen={setOpenBeBornWellDrawer}
					handleNotPregnant={handleNotPregnantClick}
					handleContinueToBooking={handleContinueToBooking}
					onShowBeBornWellCard={handleShowBeBornWellCard}
					onShowBeBornWellNotRegister={() => {}}
				/>
			) : null}

			{showBeBornWellCard ? (
				<BeBornWellCard continueToBooking={handleContinueToBooking} />
			) : null}

			{!showBeBornWellCard ? (
				<Fragment>
					<SpecialtyNotAvailableBeBornCard
						handleSelectCard={handleSelectCard}
						handleCheckDuplicity={handleCheckDuplicity}
					/>
					<StyledCard
						data-tag-id={
							WellBornTaggingEnum.VISUALIZOU_CARD_QUERO_ME_INSCREVER_APOS_RECUSA
						}>
						<StyledCardMedia
							component="img"
							image={BeBornWellImgDesktop}
							alt="BeBornWellCard"
						/>
						<StyledCardContent>
							<TitleTypography>{beBornWellStep.title}</TitleTypography>
							<DescriptionTypography>
								{beBornWellStep.description}
							</DescriptionTypography>
							<Button
								data-tag-id={
									WellBornTaggingEnum.CLICK_QUERO_ME_INSCREVER_APOS_RECUSA
								}
								variant="text"
								onClick={() => {
									if (selectedSpecialty) {
										handleRegisterClick(selectedSpecialty);
									}
								}}
								disabled={isProcessing}
								endIcon={
									isProcessing ? (
										<Loading color="inherit" size={16} />
									) : (
										<Icon name="arrow-right" size={20} />
									)
								}>
								{buttons.register}
							</Button>
						</StyledCardContent>
					</StyledCard>
				</Fragment>
			) : null}

			<PendingDialog
				open={
					checkBookingModal === CheckBookingModalEnum.VERIFYING_AUTH ||
					checkBookingModal === CheckBookingModalEnum.VERIFYING_DUPLICITY ||
					checkBookingModal === CheckBookingModalEnum.VERIFYING_DISTRICTS ||
					checkBookingModal === CheckBookingModalEnum.VERIFYING_REQUEST_SCHEDULE
				}
				text={loadingText}
			/>
		</Fragment>
	);
}
